import Modal from 'components/Modal';
import SlideModal from 'components/SlideModal';
import { FC, useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';
import { MAX_WIDTH_MOBILE } from 'utils/constant';
import styles from './CareProviderInfoPopup.module.scss';
import { t } from 'i18next';
import Button from 'components/Button';

interface Props {
  isOpen: boolean;
  value: ICareProviderInfo;
  onClose?: () => void;
}

interface ICareProviderInfo {
  name: string;
  imgPath: string;
  position: string[];
  title: string[];
  qualifications: string[];
}

const CareProviderInfoPopup: FC<Props> = ({ isOpen, value, onClose }) => {
  const isMobile = useMediaQuery({ maxWidth: MAX_WIDTH_MOBILE });

  const popup = useMemo(
    () => (
      <div className={styles.container}>
        <div className={styles.imgWrapper}>
          <img className={styles.img} src={value.imgPath} alt="" />
        </div>
        <div className={styles.basic}>
          <div className={styles.name}>{value.name}</div>
          {value.position.map((position, idx) => (
            <div key={'position_' + idx}>{position}</div>
          ))}
          {value.title.map((title, idx) => (
            <div key={'title_' + idx}>{title}</div>
          ))}
        </div>
        <div className={styles.qualification}>
          <div className={styles.title}>{t('qualification')}</div>
          <div className={styles.content}>
            {value.qualifications.map((qualification, idx) => (
              <div key={'qualification_' + idx}>{qualification}</div>
            ))}
          </div>
        </div>
        <div className={styles.closeBtn}>
          <Button type="primary" onClick={onClose}>
            <span className={styles.closeBtnText}>{t('close')}</span>
          </Button>
        </div>
      </div>
    ),
    [value]
  );

  return isMobile ? (
    <SlideModal isOpen={isOpen} onClose={() => {}}>
      {popup}
    </SlideModal>
  ) : (
    <Modal isOpen={isOpen}>{popup}</Modal>
  );
};
export default CareProviderInfoPopup;
